const sell = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><rect width="6" height="1.5" x="5" y="7.25"/></svg>',
};

export { sell as default };
